import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60b07118"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cropper-wrapper"
}
const _hoisted_2 = { class: "crop-header-controls" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close-light" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-crop" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Done ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "crop-controls" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-rotate-left" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Rotate")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-rotate-right" }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Rotate")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cropper = _resolveComponent("cropper")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_ctx.image?.url)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["prevent"]))
          }, _hoisted_5),
          _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleCrop && _ctx.handleCrop(...args)), ["prevent"])),
            class: _normalizeClass({ 'disabled-ui': _ctx.lockUI })
          }, _hoisted_8, 2)
        ]),
        _createVNode(_component_cropper, {
          ref: "crop",
          class: "cropper",
          "image-restriction": "stencil",
          src: _ctx.image.url,
          "stencil-size": !_ctx.isCaseCropper ? { width: '280', height: '280'} : null,
          "default-size": _ctx.isCaseCropper ? _ctx.defaultSize : null,
          "stencil-props": _ctx.isCaseCropper ? _ctx.caseStencil : _ctx.profileStencil,
          canvas: false,
          onReady: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loader = ''))
        }, null, 8, ["src", "stencil-size", "default-size", "stencil-props"]),
        _createElementVNode("div", _hoisted_9, [
          (!_ctx.hideRotateLeft)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleRotateLeft && _ctx.handleRotateLeft(...args)))
              }, _hoisted_12))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleRotateRight && _ctx.handleRotateRight(...args)))
          }, _hoisted_15)
        ]),
        (_ctx.loader)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: _ctx.loader
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}